// 🎨 color palette
export const COLORS = {
	mainBlue: '#1f39ca',
	lightBlue: '#4c61d5',
	mainAqua: '#48bea2',
	lightAqua: '#7fd1be',
	white: '#fefefe',
	grey: '#333333',
	lightGrey: '#727272',
	somGreen:'#97efb5',
	somOrange:'#ec8f42'
};

export const SIZE = {
	small: '576px',
	medium: '768px',
	large: '992px',
	extraLarge: '1200px'
};
